



















































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Spinner } from 'vue-image-spinner2';
import moment from 'moment-timezone';
import _ from 'lodash';
import { questionStoreBadge } from '@/utils';

@Component({
    name: 'questions',
    data: function () {
        return {
            questionsPage_: 1,
        };
    },
    components: {
        Spinner,
    },
    filters: {
        date(val) {
            console.log(val);

            return val == null ? 'Seleccionar fecha' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('questions', [
            'recordQuestions',
            'questionsTotalPO',
            'questionsTotalMeli',
            'recordQuestionsLoading',
            'pendingQuestions',
            'pendingQuestionsLoading',
            'questionsPerPage',
            'questionsPage',
            'questionsTotal',
            'responseTime',
        ]),
        ...mapState('auth', ['currentUser']),
    },
})
export default class Questions extends Vue {
    questionStoreBadge = questionStoreBadge;
    public recordQuestions!: any;
    public recordQuestionsLoading!: any;

    public pendingQuestions!: any;
    public pendingQuestionsLoading!: any;

    public questionsPerPage!: any;
    public questionsPage!: any;
    public questionsPage_!: any;
    public question_word_search: any = '';
    public questionsTotal!: any;
    private currentUser!: any;
    private activeQuestionLoaded: boolean = false;
    public question_search: any = '';
    public display: boolean = false;

    public responseTime!: any;
    public questionsType = false;
    public dateRange: any = {
        startDate: null,
    };
    singleDatePicker: any = 'single';

    busyRecords: boolean = false;
    scrollContRecords: number = 0;

    pendingInterval: any = null;

    answereval: boolean = false;

    pendingQuestionsHeaders = [
        { thClass: 'th', key: 'post_info', label: 'Publicación' },
        { thClass: 'th', key: 'message', label: 'Pregunta' },
        { thClass: 'th', key: 'edit', label: '' },
    ];
    recordQuestionsHeaders = [
        { thClass: 'th', key: 'post_info', label: 'Publicación' },
        { thClass: 'th', key: 'messages', label: 'Conversación' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    fastAnswers = [
        { name: 'COTIZACION', data: 'El paquete con el material que nos solicita tendría un costo de' },
        { name: 'ENLACE', data: 'Le comparto el enlace, en la descripción específica lo que contiene la publicación' },
        {
            name: 'GRATIS',
            data: '¡Hola! gracias por ponerte en contacto con nosotros. Los envíos gratis son cálculos de mercado libre para sus clientes en productos nuevos desde $299',
        },
        {
            name: 'FULL',
            data: '¡Hola! gracias por ponerte en contacto con nosotros. Este producto es categoría "FULL" lo cual quiere decir que tu producto se encuentra en una bodega de Mercado Libre y ellos se encargan de que lo recibas en la fecha establecida. Para revisar fechas de recepción de producto y costo de envío haz clic debajo del precio de la publicación',
        },
        {
            name: 'ENVIOS',
            data: 'Hacemos envíos a todo el país. Si deseas saber el costo de tu envío o fecha estimada de entrega lo puedes corroborar debajo del precio en la publicación',
        },
        { name: 'SALUDO', data: '¡Hola! gracias por contactarnos' },
        {
            name: 'POLITICA',
            data: 'Lo sentimos, por políticas de mercado libre no podemos compartir o solicitar información personal o links fuera de este sitio en los comentarios de la publicación',
        },
        {
            name: 'FACTURA',
            data: '¡Hola! Claro, todos nuestros precios incluyen IVA y ofrecemos servicio de facturación. Sin embargo, la factura será emitida una vez que tu paquete haya sido entregado, asegurando así tu completa satisfacción con el producto. Cuando se cumpla este requisito, podrás solicitar el enlace de autofacturación a través de un mensaje privado, ya que las políticas de mercado libre prohíben compartir información personal. ¡Esperamos con gusto tu compra! Saludos, Prodelec Mx - Tienda Oficial.',
        },
        { name: 'GRACIAS', data: '¡Gracias por tu preferencia!, si requieres de factura puedes enviarnos un mensaje con tus datos' },
        {
            name: 'AVISO',
            data: 'AVISO: Estimados clientes, con motivo de las fiestas navideñas las facturas de las compras realizadas después del 23 de diciembre se estarán enviando en el mes de enero. Prodelec agradece su comprensión y les desea felices fiestas',
        },
        {
            name: 'NAVIDAD',
            data: '¡Hola, gracias por ponerte en contacto!, todas las series de navidad incluyen un regulador de luces para que ajustes el movimiento a tu preferencia y el enchufe está adaptado para añadir otra serie',
        },
        { name: 'SIN STOCK', data: 'Una disculpa, pero por el momento no contamos con existencia del producto' },
        {
            name: 'STOCK',
            data: 'Tenemos existencia, oferta sin problemas. Si deseas más de un producto puedes ajustar la cantidad cerca del botón de pago',
        },
        {
            name: 'CONECTANDO SOLUCIONES...',
            data: '¡Esperamos tu compra! Saludos Prodelec Mx Tienda Oficial',
        },
    ];

    setUrlSearch(search: string) {
        search = search.trim();
        this.$router.push({
            path: 'questions',
            query: {
                ...this.$route.query,
                search,
            },
        });
        //     if (this.dateRange.start_date) {
        //         let start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
        //         this.$store.dispatch('questions/getAllXDay', start_date);
        //     } else {
        //         this.$store.dispatch('questions/getAllRecord', { search, page: this.questionsPage_ });
        //     }
        this.$store.dispatch('questions/getAllRecord', { search, page: this.questionsPage_ });
    }

    loadMoreRecords() {
        if (!this.$route.query.search) {
            if (!this.questionsType) {
                this.busyRecords = true;
                console.log(this.recordQuestions);
                this.scrollContRecords = this.recordQuestions.length;
                this.scrollContRecords = this.scrollContRecords + 3;
                console.log(this.scrollContRecords);

                console.log(this.dateRange.start_date);

                // this.$store.dispatch('questions/pushRecords', { record: this.scrollContRecords, start_date: this.dateRange.start_date });
                this.$store.dispatch('questions/pushRecords', { record: this.scrollContRecords, start_date: this.dateRange.start_date  });
                setTimeout(() => {
                    this.busyRecords = false;
                }, 1000);
            }
        }
    }

    setUrlPage(page: any) {
        this.$router.push({
            path: 'questions',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.questionsPage_ = page;
    }

    clearFilters() {
        this.question_word_search = '';
        this.$router.push({
            path: 'questiontions',
            query: {},
        });
        this.questionsPage_ = 1;
    }

    onGetAnswer(id: any, answer: any, modal_id: any) {
        this.pendingQuestions.forEach((question: any) => {
            question.id == id ? (question.send = question.send + answer) : question.send;
        });
        this.$bvModal.hide(modal_id);
    }

    onSendQuestion(id: any, message: any, store: any) {
        let updated_by = this.currentUser.first_name + ' ' + this.currentUser.last_name;
        this.$store.dispatch('questions/postQuestion', { id, message, store, updated_by });
    }

    onBlockUser(id: any, store: any, client_id: any) {
        this.$store.dispatch('questions/blockUser', { id, store, client_id });
    }

    onDeleteQuestion(id: any, store: any) {
        this.$store.dispatch('questions/deleteQuestion', { id, store });
    }

    getRecords() {
        this.scrollContRecords = 0;
        this.scrollContRecords = this.scrollContRecords + 3;
        // this.$store.dispatch('questions/pushRecords', { record: this.scrollContRecords, start_date: this.dateRange.start_date});
        this.$store.dispatch('questions/pushRecords', { record: this.scrollContRecords, start_date: this.dateRange.start_date });
        this.questionsType = false;
    }

    // @Watch('$route')
    getPending(flag: boolean) {
        let offset = 0;
        this.pendingQuestions.length > this.questionsTotal ? (offset = 0) : (offset = this.pendingQuestions.length);
        flag ? (offset = 0) : offset;
        this.$store.dispatch('questions/getAllPending', { offset });
        this.questionsType = true; //var to validate infiniteScroll inside records
    }

    canSee(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        let user2Id = '69480895-26e4-4930-b376-b34efe3675ec'; //wendy
        let userdId = '69398834-1969-4dd8-bece-deff3c13404b'; //development
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id != user1Id && this.currentUser.id != user2Id && this.currentUser.id != userdId) {
                    roleValidation = false;
                }
                break;
            default:
                roleValidation = false;
                break;
        }
        return roleValidation;
    }

    // @Watch('$route')
    // getAllAnswered() {
    //     // @ts-ignore
    //     console.log(start_date);

    //     const start_date = this.$route.query.start_date || null;
    //     this.$store.dispatch('questions/getAllXDay', {
    //         start_date,
    //     });
    // }
    
    mounted() {
        this.getPending(true);
        this.questionsType = true;
        this.questionsPage_ = 1;
        this.pendingInterval = setInterval(() => {
            this.getPending(true);
        }, 300000);
    }

    destroyed() {
        clearInterval(this.pendingInterval);
    }
    onFilterDateRange() {
        console.log(this.dateRange.startDate);

        let start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
        console.log(start_date);

        this.$router.push({
            path: 'questions',
            query: {
                ...this.$route.query,
                start_date: start_date,
            },
        });
        console.log(start_date);

        this.$store.dispatch('questions/pushRecords', { record: this.scrollContRecords, start_date: start_date });

        // this.$store.dispatch('questions/getAllXDay', start_date);
    }
    copyToClipboard(respuesta: any) {
        navigator.clipboard.writeText(respuesta);
    }
    
    evaluate_suggestion(id: any, evaluation: number){
    //data.item.evaluation = 0;
    //console.log(evaluate)
     this.answereval = true;
     this.$store.dispatch('questions/evaluar', { id, evaluation});
    }
}
